var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
var AuthGuard = /** @class */ (function () {
    function AuthGuard(router, localStorage, activatedRoute) {
        this.router = router;
        this.localStorage = localStorage;
        this.activatedRoute = activatedRoute;
        this.isLoggedIn = false;
    }
    AuthGuard.prototype.canActivate = function (route, state) {
        this.currentUrl = state.url;
        this.isPartner = localStorage.getItem('isPartner');
        console.log(this.currentUrl);
        console.log("this.isPartner", this.isPartner);
        if (this.isPartner == "true" && this.currentUrl == "/dashboard") {
            this.router.navigateByUrl('/login');
        }
        else {
            return this.checkLogin(this.currentUrl);
        }
    };
    AuthGuard.prototype.checkLogin = function (url) {
        this.token = localStorage.getItem('user');
        console.log('token', this.token);
        if (this.token !== null) {
            console.log(this.currentUrl);
            return true;
        }
        else {
            this.router.navigateByUrl('/login');
        }
    };
    AuthGuard = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [Router, LocalStorageService, ActivatedRoute])
    ], AuthGuard);
    return AuthGuard;
}());
export { AuthGuard };



//////////////////
// WEBPACK FOOTER
// ./src/app/route-guard.ts
// module id = ./src/app/route-guard.ts
// module chunks = main